import React, { useState, useEffect, useRef } from 'react'
import axios from '../../../../../../data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import DateTimeFunctions from '../../../../../../Classes/dateTimeFunctions'
import i18n from '../../../../../../i18n'

export default function CampaignExports({ campaign }) {
    const [reports, setReports] = useState(null)
    const timer = useRef(null)

    const getExports = async () => {
        console.log('hello')
        const res = await axios.get('/campaign/' + campaign.id + '/export')
        setReports(res.data)
        if (res.data.some(r => !r.finished)) timer.current = setTimeout(getExports, 5000)
    }

    const download = async (exportJob) => {
        if (exportJob.location) {
            let exportJobRes = await axios.get('/campaign/' + campaign.id + '/export/' + exportJob.id + '/file')
            const link = document.createElement('a');
            link.href = exportJobRes.data.url
            document.body.appendChild(link);
            link.click();
        }
    }

    useEffect(() => {
        if (campaign.id) getExports()
        return function () {
            if (timer.current) clearTimeout(timer.current)
        }
    }, [campaign.id])

    if (!reports) return <LoadingIcons />

    const data = reports.map(report => {
        let statusClass = ''
        if (report.finished) statusClass = 'square-chip-primary'
        else if (report.status === 'queued') statusClass = 'square-chip-secondary'
        else if (report.status === 'errored') statusClass = 'square-chip-red'
        const types = { clicked: 'Clicked', clickedFull: 'Clicked Detail', bounced: 'Bounced', opened: 'Opened', unsubscribed: 'Unsubscribed', sent: 'Sent', }
        return {
            datetime: {
                headerValue: 'Start Date',
                value: DateTimeFunctions.formatDateTime(report.createdAt)
            },
            type: {
                headerValue: 'Type',
                value: types[report.filters.type] || "Sent"
            },
            status: {
                headerValue: 'Status',
                value: <SquareChip className={statusClass}>{report.status}</SquareChip>
            },
            download: {
                align: 'right',
                headerValue: ' ',
                value: report.finished ? <Button className="button-sml button-primary" onClick={() => download(report)}>{i18n.t('campaigns:reports.download')}</Button> : ''
            }
        }
    })

    return (
        <div>
            <Paper>
                <h4 className="mar-b25">{i18n.t('campaigns:exports.header')}</h4>
                <DataTable1
                    noResultsText="No Exports Found"
                    tableData={data}
                />
            </Paper>

        </div>
    );
}